/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

import { TableMultiSelectCheckbox } from 'bundles/admin-shared/components/TableMultiSelect';
import { Td, Tr } from 'bundles/admin-shared/components/styledTableComponents';
import StaffPermissionsLink from 'bundles/staff-management/src/StaffPermissionsLink';

// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
import { staffTableRowKey } from '../../StaffTable';
import type { StaffTableRow } from '../../types';
import RowActions from './RowActions';

interface Props {
  row: StaffTableRow;
}

const styles = {
  wrappedTd: () => css`
    overflow-wrap: anywhere;
  `,
  nameEmailTd: () => css`
    ${styles.wrappedTd()}
    width: 35%;
  `,
  rolesTd: () => css`
    ${styles.wrappedTd()}
    width: 20%;
  `,
};

const TableRow = ({ row }: Props) => {
  const { id, fullName, email, rolesLabel } = row;

  return React.useMemo(
    () => (
      <Tr role="row">
        <Td>
          <TableMultiSelectCheckbox id={staffTableRowKey(row)} />
        </Td>
        <Td css={styles.nameEmailTd}>
          <Typography2 component="p" className="pii-hide fs-exclude" data-e2e="row-name">
            <StaffPermissionsLink id={id}>{fullName}</StaffPermissionsLink>
          </Typography2>
        </Td>
        <Td css={styles.nameEmailTd}>
          <Typography2 component="p" className="pii-hide fs-exclude" data-e2e="row-email">
            {email}
          </Typography2>
        </Td>
        <Td css={styles.rolesTd}>
          <Typography2 component="p" data-e2e="row-roles">
            {rolesLabel}
          </Typography2>
        </Td>
        <Td>
          <RowActions row={row} />
        </Td>
      </Tr>
    ),
    [email, fullName, id, rolesLabel, row]
  );
};

export default TableRow;
